import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EmbryoService } from 'src/app/Services/Embryo.service';
import { environment } from "../../../environments/environment.prod";
@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {
	lang: any;
			fileSrc:any
  constructor(public embryoService: EmbryoService , private sanitizer: DomSanitizer) { 
    		  this.lang = localStorage.getItem("lang");
		    	this.embryoService.emitLang.subscribe((lang: any) => {
					this.lang = localStorage.getItem("lang");
           this.fileSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
															environment.api + '/'+ this.lang + '/blog'
													);
			});
  }

  ngOnInit(): void {
  }



}
